import React, { lazy } from "react";
const Home = lazy(() => import("../views/home"));
const Register = lazy(() => import("../views/register"));
const Login = lazy(() => import("../views/login"));
const CustomerSupport = lazy(() => import("../views/customerSupport"));
const ClientCode = lazy(() => import("../views/clientCode"));
const Help = lazy(() => import("../views/help"));
const Profile = lazy(() => import("../views/profile"));
const PrivacyPolicy = lazy(() => import("../views/privavyPolicy"));
const TermAndConditions = lazy(() => import("../views/tnc"));
const AppDetails = lazy(() => import("../views/appDetails"));

export const ProtectedRoutes = [
  {
    path: "/home",
    component: Home,
  },

  {
    path: "/nutrition",
    component: AppDetails,
  },
  {
    path: "/rewards",
    component: AppDetails,
  },
  {
    path: "/movement",
    component: AppDetails,
  },
  {
    path: "/mental-health",
    component: AppDetails,
  },
  {
    path: "/marketplace",
    component: AppDetails,
  },
  {
    path: "/help",
    component: Help,
  },
  {
    path: "/profile",
    component: Profile,
  },
];

export const routes = [
  {
    path: "/",
    component: <Login />,
  },
  {
    path: "/register",
    component: <Register />,
  },
  {
    path: "/customer-support",
    component: <CustomerSupport />,
  },
  {
    path: "/client-code",
    component: <ClientCode />,
  },
  {
    path: "/privacy-policy",
    component: <PrivacyPolicy />,
  },
  {
    path: "/terms-and-conditions",
    component: <TermAndConditions />,
  },
];
